import { render } from "./NormatividadModal.vue?vue&type=template&id=0b6f495b"
import script from "./NormatividadModal.vue?vue&type=script&lang=js"
export * from "./NormatividadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__